import queryString from 'query-string';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { logoutUser } from '../store/authSlice';

const useFetch = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const { prefix } = queryString.parse(location.search);
    if (prefix) {
      sessionStorage.setItem('prefix', prefix);
    }
  }, [location.search]);

  return useCallback(
    (url, opts) => {
      return new Promise((resolve, reject) => {
        const prefix = sessionStorage.getItem('prefix');
        const modifiedUrl = prefix ? url.replace('/api/admin', `/${prefix}/admin`) : url;
        fetch(modifiedUrl, {
          method: 'GET',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
          },
          redirect: 'error',
          referrer: 'no-referrer',
          ...opts,
        })
          .then((res) => {
            if ([200, 201, 304].includes(res.status)) {
              return res
                .json()
                .then(resolve)
                .catch(() => resolve({}));
            } else if ([202, 204].includes(res.status)) {
              resolve({});
            } else if (res.status === 401 && !opts?.noLoginRedirect) {
              dispatch(logoutUser());
              res
                .json()
                .then((res) => {
                  reject(new Error(res.message));
                })
                .catch(() => {
                  reject(new Error('Unable to authenticate'));
                });
            } else if (res.status === 502 || res.status === 500) {
              res
                .json()
                .then((res) => {
                  reject(res);
                })
                .catch(() => {
                  reject(new Error(`Unable to parse response: ${res.body}`));
                });
            } else {
              res
                .json()
                .then((res) => {
                  reject(res);
                })
                .catch(() => {
                  reject(new Error(`Unable to parse response: ${res.body}`));
                });
            }
          })
          .catch((e) => {
            console.log(`Unhandled error for request ${url}, ${opts}: ${e.message}`);
            reject(e);
          });
      });
    },
    [dispatch]
  );
};

export default useFetch;
